import { render, staticRenderFns } from "./ExtractionPurPaymentApplyJS.vue?vue&type=template&id=24b9643a&scoped=true"
import script from "./ExtractionPurPaymentApplyJS.vue?vue&type=script&lang=js"
export * from "./ExtractionPurPaymentApplyJS.vue?vue&type=script&lang=js"
import style0 from "./ExtractionPurPaymentApplyJS.vue?vue&type=style&index=0&id=24b9643a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9643a",
  null
  
)

export default component.exports